<p>{{ message ?? 'rerunTask.text' | translate }}</p>

<button mat-flat-button (click)="onRerunTask()">
  {{ 'rerunTask.buttonLabel' | translate }}
</button>
